/* eslint-disable jsx-a11y/click-events-have-key-events -- TODO */
import type { ReactNode } from "react";

import { cn } from "../../../utils";
import type { OnCellClick, TableColumn, TableRowType } from "..";

export interface TableCellProps<
  Row extends TableRowType,
  Group extends string = never,
> {
  row: Row;
  column: TableColumn<Row, Group>;
  rowIndex: number;
  cellIndex: number;
  className?: string;
  isRowOpen?: boolean;
  isRowActive?: boolean;
  onCellClick?: OnCellClick<Row>;
}

export const TableCell = <
  Row extends TableRowType,
  Group extends string = never,
>({
  row,
  column,
  rowIndex,
  cellIndex,
  className,
  isRowOpen = false,
  isRowActive = false,
  onCellClick,
}: TableCellProps<Row, Group>) => {
  const handleClick = () => {
    onCellClick?.({ row, rowIndex, cellIndex });
    column.onClick?.({ row, rowIndex, cellIndex });
  };

  return (
    <div
      role="button"
      tabIndex={-1}
      className={cn(
        "ui:relative ui:flex ui:items-center ui:p-3 ui:text-xs ui:sm:px-1",
        className,
        typeof column.cellClassName === "string"
          ? column.cellClassName
          : column.cellClassName?.({ row, column, rowIndex, cellIndex }),
      )}
      onClick={handleClick}
    >
      {column.cell?.(row, {
        rowIndex,
        cellIndex,
        isRowOpen,
        isRowActive,
      }) ?? (row[column.id as keyof Row] as ReactNode)}
    </div>
  );
};
